<script lang="ts">
  export let size: any = 16;
  // export let color: string = '#45B36B';
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class || "stroke-brand-green-50"}
>
  <path
    d="M2.66602 8L6.66602 12L13.3327 4"
    stroke-width="1.66667"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
